import React from 'react';
import { connect } from 'react-redux';
import { tilPengerFormat, tilDagOgManed } from '../../Shared/Scripts/Utilities/Formatters';
import { TerminPeriode, Termin } from '../Models/Utbetalingsplan';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';

interface UtbetalingSemesterOwnProps {
    terminer: TerminPeriode | null;
    erVar?: boolean;
    tabellOverskriftKey: keyof VeilederVgsUrDto;
}

type UtbetalingSemesterProps = UtbetalingSemesterOwnProps & MapStateToProps & {};

const utbetalingSemesterComponent = (props: UtbetalingSemesterProps): JSX.Element | null => {
    if (props.terminer != null) {
        const { locale } = props.epiContext;
        const { erVar, tabellOverskriftKey, epiContext } = props;

        const headerCellStyles = ['c-table__header-cell', erVar === true ? 'c-table__header-cell--lilac' : ''].join(
            ' ',
        );

        return (
            <div className="c-veileder__content">
                <h4 className="c-veileder__tittel c-veileder__tittel--info">
                    {contentResolver(epiContext, tabellOverskriftKey)}
                </h4>
                <div role="table" className="c-table">
                    <div role="row" className="c-table__header-row">
                        <div role="columnheader" className={headerCellStyles}>
                            {contentResolver(epiContext, 'kolonneTttelDato')}
                        </div>
                        <div role="columnheader" className={headerCellStyles}>
                            {contentResolver(epiContext, 'kolonneTittelBelop')}
                        </div>
                    </div>
                    {props.terminer.terminer.map(
                        (termin: Termin): JSX.Element => (
                            <div role="row" className="c-table__data-row" key={`host${termin.mnd}`}>
                                <div role="cell" className="c-table__data-cell">
                                    {tilDagOgManed(termin.mnd - 1, 15, locale)}
                                </div>
                                <div role="cell" className="c-table__data-cell">{`${tilPengerFormat(
                                    termin.terminbelop,
                                    locale,
                                )} ${epiContext.valuta}`}</div>
                            </div>
                        ),
                    )}
                </div>
            </div>
        );
    } else {
        return null;
    }
};

interface MapStateToProps {
    epiContext: EpiContext<VeilederVgsUrDto>;
}

export default connect(
    (state: EpiAppStateMedSteg<VeilederVgsUrDto>): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(utbetalingSemesterComponent);
